import { Component, OnInit, OnDestroy, Input} from '@angular/core';
import { uniqueId } from './lib/helpers';
import { SearchResult, SearchService } from './search.service';
import { FilterService } from './filter.service';
import { BreadCrumbsService } from './breadcrumbs.service';
import { CatalogService } from './catalog/catalog.service';
import { NavigationEnd, Router } from '@angular/router';
import { SubscriptionLike } from 'rxjs';

@Component({
  selector: 'app-search',
  templateUrl: '../templates/search.component.html',
  styleUrls: ['../styles/components/search.component.less']
})
export class SearchComponent implements OnInit, OnDestroy {
  searchPhrase = '';
  formIsOpen = false;
  fastSearchOpen = false;
  triggerTimeout: number;
  id = uniqueId('search_');
  @Input('crumbStyle') crumbStyle: string;
  @Input('searchStyle') searchStyle: string;
  results: SearchResult[] = [];
  placeholder = false;
  subscription: SubscriptionLike;

  constructor(
    private searchService: SearchService,
    private catalogService: CatalogService,
    public filter: FilterService,
    public breadCrumbsService: BreadCrumbsService,
    private router: Router,
  ) {}

  public ngOnInit() {
    this.subscription = this.router.events.subscribe((e) => {
      if (!(e instanceof NavigationEnd)) return;
      this.clearForm();
    });
  }

  public ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  triggerSearch() {
    if (typeof window !== 'undefined') {
      window.clearTimeout(this.triggerTimeout);
      this.triggerTimeout = window.setTimeout(() => this.fastSearch(), 500);
    }
  }

  async fastSearch() {
    this.fastSearchOpen = !!this.searchPhrase;
    this.placeholder = true;
    try {
      let data: SearchResult[] = await this.searchService.search({
        q: this.searchPhrase,
        navParams: {nPageSize: 4}
      });

      data = data.filter((item) => item.PARAM1 === 'catalog');

      data.forEach(async(item, i) => {
        if (item.ITEM_ID.startsWith('S')) return;
        const el = await this.catalogService.getByCode(item.ITEM_ID);
        data[i].CRUMBS = [{
          name: 'Магазин',
          href: '/',
          color: 'general-primary'
        },
        {
          name: el.IBLOCK_SECTION.NAME,
          href: '/catalog/section/' + el.IBLOCK_SECTION.ID,
          color: 'general-primary'
        }];
      });
      this.results = data;
      this.placeholder = false;
    } catch (e) {
      this.fastSearchOpen = false;
    }
  }

  clearForm() {
    this.formIsOpen = false;
    this.fastSearchOpen = false;
    this.searchPhrase = '';
    this.results = [];
    // this.fastSearch();
  }

  closeFastSearch() {
    if (typeof window !== 'undefined') {
      window.setTimeout(() => this.fastSearchOpen = false, 500);
    }
  }

  openForm() {
    this.formIsOpen = true;
  }
}
